import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectAxnAdminSecurityRuleId } from "@utils/parameter-injector";

type CreateAxnAdminSecurityRuleRequestResponse = {
    response: AxnAdminSecurityRule;
};

export const createAxnAdminSecurityRuleRequest = async (
    securityRule: AxnAdminSecurityRule
): Promise<GenericNetworkResponse<CreateAxnAdminSecurityRuleRequestResponse>> => {
    const route = injectAxnAdminSecurityRuleId(apiRoutes.managementConsole.axnadmin.security.ruleWithId, "");

    const body: AxnAdminSecurityRule = {
        ...securityRule,
        className: securityRule.className ? securityRule.className : null,
        pathText: securityRule.pathText ? securityRule.pathText : null,
        rule: securityRule.rule ? securityRule.rule : null,
        ruleName: securityRule.ruleName ? securityRule.ruleName : null,
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};